import { useEffect, useState } from 'react'
import { breakpoints } from 'globalStyles'

const useDetectPhone = () => {
  const [mQuery, setMQuery] = useState({
    matches: globalThis.matchMedia(breakpoints.phone).matches,
  })

  useEffect(() => {
    const mediaQueryList = globalThis.matchMedia(breakpoints.phone)
    mediaQueryList.addEventListener('change', setMQuery)
    return () => mediaQueryList.removeEventListener('change', setMQuery)
  }, [])

  return mQuery.matches
}

export default useDetectPhone
